import type { Account } from '@limo/database'
import type { OnboardingSupplementaryData } from '@/lib/onboarding'
import { evaluateOnboarding } from '@/lib/onboarding'
import { Progress } from '@/components/ui/progress'
import { cn } from '@/lib/utils'

interface Props {
  account: Account
  data: OnboardingSupplementaryData | undefined
  onClick: () => void
}

function getProgressColor(percentage: number): string {
  if (percentage === 100) return '[&>div]:bg-green-500'
  if (percentage >= 60) return '[&>div]:bg-blue-500'
  if (percentage >= 30) return '[&>div]:bg-amber-500'
  return '[&>div]:bg-red-500'
}

export function OnboardingProgressCell({ account, data, onClick }: Props) {
  if (!data) return null

  const result = evaluateOnboarding(account, data)

  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 w-full group cursor-pointer"
      title={`${result.completedSteps.length}/${result.totalSteps} steps complete — click for details`}
    >
      <Progress
        value={result.percentage}
        className={cn('h-2 w-16', getProgressColor(result.percentage))}
      />
      <span
        className={cn(
          'text-xs font-medium tabular-nums',
          result.percentage === 100 ? 'text-green-600' : 'text-muted-foreground'
        )}
      >
        {result.percentage}%
      </span>
    </button>
  )
}
